import { Link } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import { movies } from "@/mocks/data";

interface MovieSectionProps {
  title: string;
  subtitle?: string;
  icon?: string;
  linkTo?: string;
  linkLabel?: string;
  filter: (m: typeof movies[number]) => boolean;
  limit?: number;
}

export default function MovieSection({ title, subtitle, icon, linkTo, linkLabel, filter, limit = 8 }: MovieSectionProps) {
  const filtered = movies.filter(filter).slice(0, limit);

  if (filtered.length === 0) return null;

  return (
    <section className="py-8 md:py-12">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-6">
          <div>
            <div className="flex items-center gap-2 mb-1">
              {icon && (
                <span className="w-6 h-6 flex items-center justify-center text-primary-500">
                  <i className={`${icon} text-lg`}></i>
                </span>
              )}
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">
                {title}
              </h2>
            </div>
            {subtitle && (
              <p className="text-xs text-foreground-500 mt-1">{subtitle}</p>
            )}
          </div>
          {linkTo && (
            <Link
              to={linkTo}
              className="flex items-center gap-1 text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer no-underline whitespace-nowrap"
            >
              {linkLabel || "查看全部"}
              <i className="ri-arrow-right-line"></i>
            </Link>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-4">
          {filtered.map((movie) => (
            <MovieCard
              key={movie.id}
              id={movie.id}
              title={movie.title}
              genre={movie.genre}
              rating={movie.rating}
              poster={movie.poster}
              updateInfo={movie.updateInfo}
              isNew={movie.isNew}
              isHot={movie.isHot}
            />
          ))}
        </div>
      </div>
    </section>
  );
}